// src/features/orders/ordersService.js

import { googleSheetsService } from "../../services/googleSheetsService";

const createOrder = async (order) => {
  // Ensure items is stringified
  const itemsJson = JSON.stringify(order.items);

  // Build row according to column order
  const row = [
    order.id || `order_${Date.now()}`, // generate a simple ID if not provided
    order.userId || "",
    itemsJson,
    order.total,
    order.date,
    order.paymentId || "",
    order.paymentMethod || "",
    order.customerName || "",
    order.customerEmail || "",
    order.customerAddress || "",
    order.customerCity || "",
    order.customerZip || "",
  ];

  try {
    const response = await googleSheetsService.appendRow("Orders", row);
    return response;
  } catch (error) {
    console.error("Error adding order:", error);
    throw error;
  }
};

const getOrders = async () => {
  try {
    const rows = await googleSheetsService.getRows("Orders");
    return rows.map((row) => ({
      id: row[0],
      userId: row[1],
      items: JSON.parse(row[2] || "[]"),
      total: parseFloat(row[3]),
      date: row[4],
      paymentId: row[5],
      paymentMethod: row[6],
      customerName: row[7],
      customerEmail: row[8],
      customerAddress: row[9],
      customerCity: row[10],
      customerZip: row[11],
    }));
  } catch (error) {
    console.error("Error fetching orders:", error);
    return [];
  }
};

export const ordersService = {
  createOrder,
  getOrders,
};